module.exports = __webpack_public_path__ + "img/nedladdning.2ffcff79.png";